import * as S from "./styles.ts";
import { useTypedSelector } from "@/redux/helpers/hooks.ts";
import UserControl from "./UserControl";
import CartControl from "./CartControl";
import { Button, LoadingSpinner, UniversalLink } from "@template/components";
import useBreakpoint from "@/lib/helpers/hooks/useBreakpoint.ts";

export interface IAuthProps {
  available_trial?: boolean;
  altStyling?: boolean;
}

const LogInPrompt = ({ available_trial, altStyling }: IAuthProps) => {
  const isSm = !useBreakpoint("md").check;

  return (
    <>
      <UniversalLink href="/login">
        <Button variant="outline">Log In</Button>
      </UniversalLink>
      {available_trial && !isSm && (
        <UniversalLink href="/voip/try-free/">
          <Button variant={altStyling ? "flat" : "solid"}>Try for Free</Button>
        </UniversalLink>
      )}
    </>
  );
};

const NavAuth = ({ available_trial, altStyling }: IAuthProps) => {
  const { user, cart } = useTypedSelector((state) => state.user);
  return (
    <S.AuthContainer>
      {user.loading ? (
        <LoadingSpinner height={15} />
      ) : (
        <>
          {cart.items.length > 0 && <CartControl altStyling={altStyling} />}
          {user.authenticated ? (
            <UserControl />
          ) : (
            <LogInPrompt
              available_trial={available_trial}
              altStyling={altStyling}
            />
          )}
        </>
      )}
    </S.AuthContainer>
  );
};

export default NavAuth;
